<template>
  <div class="informacoes" v-if="valores.length > 0" style="display: flex; flex-wrap: wrap; font-size: 14px; gap: 5px;" >
    <div>
      <v-tooltip bottom style="flex: 1">
      <template v-slot:activator="{ on, attrs }" >
          <div>
            <v-icon v-bind="attrs" v-on="on" size="20" style="vertical-align: top">notification_important</v-icon>
          </div>
      </template>
      <span class="text-caption white--text">Média / Total Período</span>
    </v-tooltip>
    </div>
    <div style="display: flex; flex-wrap: wrap; justify-content:end; font-size: 14px; gap: 5px;">
      <div class="periodos" v-for="key in valores" :key="key.id">
        <i><strong>{{ key.dspravadi }}:</strong> {{ `${key.valorPromocao}/${key.valordistribuicao}` }} pts</i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InformacoesPromocaoPeriodos',
  props: {
    valores: Array,
  }
}
</script>

<style lang="scss" scoped>
.informacoes {
  cursor: pointer;

  .periodos {
    text-align: center;
  }
}


</style>
